/**
 * Cart Drawer Boost Scripts
 * - Urgency Countdown Timer (persisted in sessionStorage)
 * - Multi-tier Reward Progress Bar (Safe calculations & milestones)
 * - 1-Click AJAX Upsells (+ ADD to Dawn drawer)
 * - In-Cart Discount Code box
 */

(function () {
  let timerInterval = null;

  function formatMoney(cents) {
    if (isNaN(cents)) return '';
    const amount = (cents / 100).toFixed(2);
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      const symbol = window.Shopify.currency.symbol || '₹';
      return `${symbol}${amount.replace(/\.00$/, '')}`;
    }
    return `₹${amount.replace(/\.00$/, '')}`;
  }

  // --- 1. Urgency Countdown Timer ---
  function initUrgencyTimer() {
    const banner = document.getElementById('CartBoostUrgency');
    const timerDisplay = document.getElementById('CartBoostTimer');
    if (!banner || !timerDisplay) return;

    const minutes = parseInt(banner.getAttribute('data-minutes'), 10) || 10;
    const storageKey = 'cart_boost_timer_expiry';

    let expiryTime = parseInt(sessionStorage.getItem(storageKey), 10);
    const now = Date.now();

    if (!expiryTime || expiryTime <= now) {
      expiryTime = now + minutes * 60 * 1000;
      sessionStorage.setItem(storageKey, expiryTime);
    }

    if (timerInterval) clearInterval(timerInterval);

    function updateTimer() {
      const remainingMs = expiryTime - Date.now();
      if (remainingMs <= 0) {
        timerDisplay.textContent = '00:00';
        clearInterval(timerInterval);
        return;
      }
      const totalSec = Math.floor(remainingMs / 1000);
      const m = Math.floor(totalSec / 60);
      const s = totalSec % 60;
      timerDisplay.textContent = `${m < 10 ? '0' : ''}${m}:${s < 10 ? '0' : ''}${s}`;
    }

    updateTimer();
    timerInterval = setInterval(updateTimer, 1000);
  }

  // --- 2. Tiered Progress Bar ---
  function initProgressBar() {
    const wrap = document.getElementById('CartBoostProgress');
    if (!wrap) return;

    const mode = wrap.getAttribute('data-mode') || 'quantity';
    const isQtyMode = (mode === 'quantity');

    const cartCount = parseInt(wrap.getAttribute('data-cart-count'), 10) || 0;
    const cartTotal = parseInt(wrap.getAttribute('data-cart-total'), 10) || 0;

    const currentVal = isQtyMode ? cartCount : cartTotal;

    const t1 = parseFloat(wrap.getAttribute('data-t1')) || (isQtyMode ? 2 : 49900);
    const t2 = parseFloat(wrap.getAttribute('data-t2')) || (isQtyMode ? 3 : 99900);
    const t3 = parseFloat(wrap.getAttribute('data-t3')) || (isQtyMode ? 4 : 149900);

    const l1 = wrap.getAttribute('data-l1') || '10% OFF';
    const l2 = wrap.getAttribute('data-l2') || '15% OFF';
    const l3 = wrap.getAttribute('data-l3') || 'Free shipping';

    const msgTemplate = wrap.getAttribute('data-msg-template') || 'YOU ARE {amount} AWAY FROM GETTING {reward}';
    const completeMsg = wrap.getAttribute('data-msg-complete') || "🎉 CONGRATULATIONS! YOU'VE UNLOCKED ALL REWARDS!";

    const fillEl = wrap.querySelector('.cart-boost-bar-fill');
    const msgEl = wrap.querySelector('.cart-boost-progress-message');
    const tierCount = parseInt(wrap.getAttribute('data-tier-count'), 10) || 2;
    const node1 = wrap.querySelector('.cart-boost-node[data-step="1"]');
    const node2 = wrap.querySelector('.cart-boost-node[data-step="2"]');
    const node3 = wrap.querySelector('.cart-boost-node[data-step="3"]');

    let pct = 0;
    let nextReward = l1;
    let remaining = 0;
    let isComplete = false;

    if (tierCount === 2) {
      if (currentVal < t1) {
        pct = (currentVal / t1) * 50;
        nextReward = l1;
        remaining = t1 - currentVal;
      } else if (currentVal < t2) {
        pct = 50 + ((currentVal - t1) / (t2 - t1)) * 50;
        nextReward = l2;
        remaining = t2 - currentVal;
      } else {
        pct = 100;
        isComplete = true;
      }

      if (node1) {
        if (currentVal >= t1) {
          node1.classList.add('is-achieved');
          node1.classList.remove('is-target');
        } else {
          node1.classList.remove('is-achieved');
          node1.classList.add('is-target');
        }
      }
      if (node2) {
        if (currentVal >= t2) {
          node2.classList.add('is-achieved');
          node2.classList.remove('is-target');
        } else if (currentVal >= t1 && currentVal < t2) {
          node2.classList.remove('is-achieved');
          node2.classList.add('is-target');
        } else {
          node2.classList.remove('is-achieved', 'is-target');
        }
      }
    } else {
      if (currentVal < t1) {
        pct = (currentVal / t1) * 33.33;
        nextReward = l1;
        remaining = t1 - currentVal;
      } else if (currentVal < t2) {
        pct = 33.33 + ((currentVal - t1) / (t2 - t1)) * 33.33;
        nextReward = l2;
        remaining = t2 - currentVal;
      } else if (currentVal < t3) {
        pct = 66.66 + ((currentVal - t2) / (t3 - t2)) * 33.34;
        nextReward = l3;
        remaining = t3 - currentVal;
      } else {
        pct = 100;
        isComplete = true;
      }

      if (node1) {
        if (currentVal >= t1) {
          node1.classList.add('is-achieved');
          node1.classList.remove('is-target');
        } else {
          node1.classList.remove('is-achieved');
          node1.classList.add('is-target');
        }
      }
      if (node2) {
        if (currentVal >= t2) {
          node2.classList.add('is-achieved');
          node2.classList.remove('is-target');
        } else if (currentVal >= t1 && currentVal < t2) {
          node2.classList.remove('is-achieved');
          node2.classList.add('is-target');
        } else {
          node2.classList.remove('is-achieved', 'is-target');
        }
      }
      if (node3) {
        if (currentVal >= t3) {
          node3.classList.add('is-achieved');
          node3.classList.remove('is-target');
        } else if (currentVal >= t2 && currentVal < t3) {
          node3.classList.remove('is-achieved');
          node3.classList.add('is-target');
        } else {
          node3.classList.remove('is-achieved', 'is-target');
        }
      }
    }

    if (fillEl) fillEl.style.width = `${Math.min(pct, 100)}%`;

    if (isComplete) {
      wrap.classList.add('is-complete');
    } else {
      wrap.classList.remove('is-complete');
    }

    if (msgEl) {
      if (isComplete) {
        msgEl.textContent = completeMsg;
        msgEl.classList.add('is-complete');
      } else {
        const remainingStr = isQtyMode ? `${remaining} ${remaining === 1 ? 'ITEM' : 'ITEMS'}` : formatMoney(remaining);
        const rewardSpan = `<span class="cart-boost-reward-highlight">${nextReward}</span>`;
        const text = msgTemplate
          .replace('{amount}', remainingStr)
          .replace('{reward}', rewardSpan);
        msgEl.innerHTML = text;
        msgEl.classList.remove('is-complete');
      }
    }
  }

  // --- 3. Upsells & Cross-sells Carousel & Add to Cart ---
  function initUpsells() {
    const list = document.querySelector('.cart-boost-upsell-list');
    const prevBtn = document.getElementById('CartBoostUpsellPrev');
    const nextBtn = document.getElementById('CartBoostUpsellNext');

    if (list && prevBtn && nextBtn) {
      prevBtn.onclick = () => {
        list.scrollBy({ left: -list.offsetWidth, behavior: 'smooth' });
      };
      nextBtn.onclick = () => {
        list.scrollBy({ left: list.offsetWidth, behavior: 'smooth' });
      };
    }

    document.querySelectorAll('.cart-boost-upsell-btn').forEach((btn) => {
      if (btn.hasAttribute('data-bound')) return;
      btn.setAttribute('data-bound', 'true');

      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        const variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;

        const originalText = btn.innerHTML;
        btn.classList.add('is-loading');
        btn.innerHTML = 'Adding...';

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/javascript'
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 1,
              sections: 'cart-drawer,cart-icon-bubble'
            })
          });

          const data = await res.json();
          const drawer = document.querySelector('cart-drawer');

          if (drawer && data.sections) {
            drawer.renderContents(data);
          } else {
            window.location.reload();
          }
        } catch (err) {
          console.error('Failed to add upsell product', err);
          btn.innerHTML = originalText;
          btn.classList.remove('is-loading');
        }
      });
    });
  }

  // --- 4. Discount Code Box ---
  function initDiscountCode() {
    const form = document.getElementById('CartBoostDiscountForm');
    const input = document.getElementById('CartBoostDiscountInput');
    const chipWrap = document.getElementById('CartBoostDiscountApplied');
    const chipText = document.getElementById('CartBoostDiscountText');
    const removeBtn = document.getElementById('CartBoostDiscountRemove');
    const checkoutForm = document.getElementById('CartDrawer-Form');

    const savedCode = sessionStorage.getItem('cart_boost_discount');

    function updateCheckoutUrl(code) {
      if (!checkoutForm) return;
      let action = checkoutForm.getAttribute('action') || '/cart';
      if (code) {
        action = `/checkout?discount=${encodeURIComponent(code)}`;
      } else {
        action = '/cart';
      }
      checkoutForm.setAttribute('action', action);
    }

    if (savedCode && chipWrap && chipText) {
      chipText.textContent = savedCode;
      chipWrap.style.display = 'flex';
      if (input) input.value = savedCode;
      updateCheckoutUrl(savedCode);
    }

    if (form && input && !form.hasAttribute('data-bound')) {
      form.setAttribute('data-bound', 'true');
      form.onsubmit = (e) => {
        e.preventDefault();
        const code = input.value.trim();
        if (!code) return;

        sessionStorage.setItem('cart_boost_discount', code);
        if (chipWrap && chipText) {
          chipText.textContent = code;
          chipWrap.style.display = 'flex';
        }
        updateCheckoutUrl(code);

        fetch(`/discount/${encodeURIComponent(code)}`).catch(() => {});
      };
    }

    if (removeBtn && !removeBtn.hasAttribute('data-bound')) {
      removeBtn.setAttribute('data-bound', 'true');
      removeBtn.onclick = () => {
        sessionStorage.removeItem('cart_boost_discount');
        if (input) input.value = '';
        if (chipWrap) chipWrap.style.display = 'none';
        updateCheckoutUrl(null);
        fetch('/discount/CLEAR').catch(() => {});
      };
    }
  }

  function updateBoostUI() {
    initUrgencyTimer();
    initProgressBar();
    initUpsells();
    initDiscountCode();
  }

  // Initialize on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateBoostUI);
  } else {
    updateBoostUI();
  }

  // Hook to Dawn PubSub events safely (NO DOM mutation observers!)
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      setTimeout(updateBoostUI, 100);
    });
  }

  // Listen to drawer active class changes (ONLY on attribute class, NOT subtree!)
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    const classObserver = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.attributeName === 'class' && cartDrawer.classList.contains('active')) {
          updateBoostUI();
        }
      }
    });
    classObserver.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
  }
})();
